<template>
  <div>
   <!-- <a-tabs @change="callback">
      <a-tab-pane key="1" tab="我的标注任务">
        <LabelTask></LabelTask>
      </a-tab-pane>
      <a-tab-pane key="2" tab="我的修改任务">
        <ModifyTask></ModifyTask>
      </a-tab-pane>
    </a-tabs>-->
    <LabelTask></LabelTask>
  </div>
</template>
<script>

import LabelTask from './LabelTask'
// import ModifyTask from './ModifyTask'

export default {
  components: {
    LabelTask
    // ModifyTask
  },
  methods: {
    callback () {

    }
  }
}
</script>
<style>

</style>
